module.exports = __webpack_public_path__ + "ded9fa98fdf8e529bf3557cb7e74fef7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/game-owl.png
// module id = 2391
// module chunks = 0